import { useEffect } from "react";

const BRAND = "Equitas Homes";

/**
 * Set the browser tab title. Pass a page-specific title to prefix it
 * (e.g. "123 Main St" → "123 Main St | Equitas Homes"), or call with
 * no argument to reset to just "Equitas Homes".
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    const trimmed = (title || "").trim();
    document.title = trimmed ? `${trimmed} | ${BRAND}` : BRAND;
  }, [title]);
}
